export default {
    set(state, { data }) {
      state.flags = data;
    },
    show(state, { data }) {
      state.flag = data;
    }
  }